angular.module('impactx.legallinking').service("LegalLinking", LegalLinking);
LegalLinking.inject = ['$mdDialog'];

function LegalLinking($mdDialog) {
    var openDialog = function (event, link, title) {
        $mdDialog.show({
            controller: 'LegalLinkingCtrl',
            locals: {
                title: title,
                link: link
            },
            templateUrl: 'shared/legallinking/templates/legallinking.dialog.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            multiple: true
        });
    };

    return {
        openDialog: openDialog
    };
}